module.exports = __webpack_public_path__ + "img/anghami.d6fa114b.png";